(() => {
  const COMPONENT = "content-hotspots";

  if (customElements.get(COMPONENT)) return;

  class ContentHotspots extends HTMLElement {
    constructor() {
      super();
      this.cleanup = [];
      this.editorCleanup = null;
      this.editorActiveBlockId = null;
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleHotspotClick = this.handleHotspotClick.bind(this);
    }

    connectedCallback() {
      if (this.dataset.chInit === "true") return;
      this.dataset.chInit = "true";

      this.hotspots = Array.from(this.querySelectorAll("[data-hotspot]"));
      if (!this.hotspots.length) return;

      this.hotspots.forEach((hotspot) => {
        const button = hotspot.querySelector("[data-hotspot-button]");
        if (!button) return;
        this.addListener(button, "click", this.handleHotspotClick);
        this.setHotspotActive(hotspot, false);
      });

      this.addListener(document, "click", this.handleDocumentClick);
      this.bindEditorEvents();
    }

    disconnectedCallback() {
      if (this.editorCleanup) {
        this.editorCleanup();
        this.editorCleanup = null;
      }
      this.cleanup.forEach((remove) => remove());
      this.cleanup = [];
      this.editorActiveBlockId = null;
      delete this.dataset.chInit;
    }

    addListener(el, event, handler, options) {
      if (!el) return;
      el.addEventListener(event, handler, options);
      this.cleanup.push(() => el.removeEventListener(event, handler, options));
    }

    bindEditorEvents() {
      if (
        !window.webvista ||
        typeof window.webvista.bindShopifyEditorBlockEvents !== "function"
      ) {
        return;
      }

      this.editorCleanup = window.webvista.bindShopifyEditorBlockEvents({
        root: this,
        getBlockElement: (blockId) =>
          this.querySelector(`[data-hotspot][data-block-id="${blockId}"]`),
        onSelect: ({ blockId, blockElement }) => {
          const hotspot =
            blockElement && blockElement.matches("[data-hotspot]")
              ? blockElement
              : null;
          if (!hotspot) return;
          this.editorActiveBlockId = blockId;
          this.clearActive();
          this.setHotspotActive(hotspot, true);
        },
        onDeselect: ({ blockId }) => {
          if (!blockId || blockId !== this.editorActiveBlockId) {
            return;
          }
          this.editorActiveBlockId = null;
          window.setTimeout(() => {
            if (this.editorActiveBlockId !== null) {
              return;
            }
            this.clearActive();
          }, 0);
        },
      });
    }

    handleHotspotClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const hotspot = event.currentTarget.closest("[data-hotspot]");
      if (!hotspot) return;

      const isActive = hotspot.dataset.active === "true";
      this.clearActive();

      if (!isActive) {
        this.setHotspotActive(hotspot, true);
      }
    }

    handleDocumentClick(event) {
      const target = event.target instanceof Element ? event.target : null;

      // Keep editor-selected hotspot open until Shopify emits block deselect.
      if (this.editorActiveBlockId !== null) {
        return;
      }

      if (!target || !this.contains(target)) {
        this.clearActive();
        return;
      }

      if (target?.closest("[data-hotspot]")) return;
      this.clearActive();
    }

    clearActive() {
      this.hotspots.forEach((hotspot) => {
        this.setHotspotActive(hotspot, false);
      });
    }

    setHotspotActive(hotspot, isActive) {
      const button = hotspot.querySelector("[data-hotspot-button]");
      const tooltip = hotspot.querySelector("[data-hotspot-tooltip]");
      const activeState = isActive ? "true" : "false";

      if (isActive) {
        hotspot.dataset.active = "true";
      } else {
        delete hotspot.dataset.active;
      }

      if (button) {
        button.setAttribute("aria-expanded", activeState);
      }

      if (tooltip) {
        tooltip.setAttribute("aria-hidden", isActive ? "false" : "true");
      }
    }
  }

  customElements.define(COMPONENT, ContentHotspots);
})();
